// extracted by mini-css-extract-plugin
export default {"medicationNameCell":"MedicationTable_medicationNameCell__67vHB"};